import { t, Trans } from '@lingui/macro';
import PropTypes from 'prop-types';
import React from 'react';

import { UppyFeatureFlagWrapper } from '@components/common/uppy/UppyFeatureFlagWrapper';
import { formattedUppyAttachment } from '@helpers/uppy';

class AssetWatermarkUppy extends React.Component {
  triggerClickHandlerRef = React.createRef();

  handleCustomizationFiles = (files) => {
    if (!files.length) { return; }

    const file = formattedUppyAttachment(files[0]);
    const $parent = $(`.j-upload-settings-well.${this.uploadType()}`);
    $('.m-asset-advanced-container').find('.j-upload-settings-well').data(`has-${this.uploadType}`, true);
    $parent.find('.filepicker_object').val(JSON.stringify({ url: file.url, filename: file.filename }));
    $parent.find('.filepicker-complete .filename').text(file.filename);
    $parent.find('.filepicker-complete .filename').attr('href', file.url);
    $parent.find('.filepicker-complete-pane').addClass('complete');
    $parent.find('#watermark-upload').hide();
    Notify.create({
      title: t`Processing watermark.`,
      body: t`Click 'Update Asset' to begin processing watermark.`,
      type: "success"
    });
  }

  uploadType = () => this.props.uploadType.toLowerCase();

  trigger = () => `uppy-watermark-trigger-${this.uploadType()}`;

  handleTriggerClick = (event) => {
    if (this.triggerClickHandlerRef.current) {
      this.triggerClickHandlerRef.current(event);
    }
  }

  renderArea = () => (
    <div className="uppy-asset-watermark" id={this.trigger()} onClick={this.handleTriggerClick}>
      <p><Trans>Click to upload</Trans></p>
    </div>
  );

  render() {
    return (
      <React.Fragment>
        {this.renderArea()}
        <UppyFeatureFlagWrapper
          {...this.props}
          button
          handleUpload={this.handleCustomizationFiles}
          restrictions={{ maxNumberOfFiles: 1, allowedFileTypes: ['image/*'] }}
          template={this.uploadType()}
          trigger={`#${this.trigger()}`}
          onTriggerClickHandler={this.triggerClickHandlerRef}
          uniqIdentifier={`uppy-watermark-${this.uploadType()}`}
        />
      </React.Fragment>
    );
  }
}

AssetWatermarkUppy.propTypes = {
  uploadType: PropTypes.string.isRequired
};

export default AssetWatermarkUppy;
